<template>
  <div class="shareBody">
      <h3 class="shareBody-access-title" v-if="peopleWithAccess.length">People with access</h3>
      <div class="selected-users-list my-2">
        <!-- <div class="accessList" v-for="client in peopleWithAccess" :key="client.id">
          <span>{{ client.name }}</span>
          <div class="s">
            <button v-if="isOnProjectLevel && (user.projectLevelRole === 'ADMIN'|| ( user.userId===client.sharedById && (user.projectLevelRole === 'COLLABORATOR' || user.projectLevelRole === 'EDITOR')))" class="btn mr-3 pointer" @click="removeAccess(client.id, client.name, client.assocId)">Remove access</button>
            <button v-if="!isOnProjectLevel && (user.tenantLevelRole === 'ADMIN'|| ( user.userId===client.sharedById && (user.tenantLevelRole === 'COLLABORATOR' || user.tenantLevelRole === 'EDITOR')))" class="btn mr-3 pointer" @click="removeAccess(client.id, client.name, client.assocId)">Remove access</button>
          </div>
        </div> -->
        <!-- new users-list start  -->
          <div v-if="selectedUsersForDisplay.length" class="selected-users-list">
          <div v-for="user in selectedUsersForDisplay" :key="`${user.tenantId}-${user.value}`" class="selected-user-card">
            <div class="selected-user-details">
            <div class="selected-user-details-avatar">{{user.label | avatarChar}}</div>
            <div>
              <div class="selected-user-name">{{ user.label }}</div>
              <div class="selected-user-tenant">{{ user.subLabel }}</div>
            </div>
            </div>
            <button class="selected-user-remove" v-tooltip="'Remove user'" @click="removeSelectedUser(user)"><img src="@/assets/images/delete-icon.svg" height="16" width="16" alt="" srcset=""></button>
          </div>
        </div>
        <!-- new users-list end  -->
        <!-- access list start  -->
          <div v-if="peopleWithAccess.length" class="selected-users-list">
          <div  v-for="client in peopleWithAccess" :key="client.id" class="selected-user-card">
            <div class="selected-user-details">
            <div class="selected-user-details-avatar">{{client.name | avatarChar}}</div>
            <div>
              <div class="selected-user-name">{{ client.name }}</div>
              <div class="selected-user-tenant">{{ client.tenantName }}</div>
            </div>
            </div>
            <button v-if="isOnProjectLevel && (user.projectLevelRole === 'ADMIN'|| ( user.userId===client.sharedById && (user.projectLevelRole === 'COLLABORATOR' || user.projectLevelRole === 'EDITOR')))" class="btn shareBody-remove-btn " @click="removeAccess(client.id, client.name, client.assocId)">Remove access</button>
            <button v-if="!isOnProjectLevel && (user.tenantLevelRole === 'ADMIN'|| ( user.userId===client.sharedById && (user.tenantLevelRole === 'COLLABORATOR' || user.tenantLevelRole === 'EDITOR')))" class="btn shareBody-remove-btn" @click="removeAccess(client.id, client.name, client.assocId)">Remove access</button>
          </div>
        </div>
        </div>
<!-- access list end -->
    <div class="shareBody-select">
      <custom-dropdown
        :list="collaborators"
        :selected="selectedTenant"
        :search-text="tenantSearchText"
        default-label="Select tenant"
        :defaultStyle="{ ddMaxWidth: '100%' }"
        @select="selectTenant"
      >
        <template #before-items>
          <div class="tenant-search-box">
            <input
              v-model.trim="tenantSearchText"
              type="text"
              class="tenant-search-input"
              placeholder="Search tenant"
              @click.stop
            >
          </div>
        </template>
      </custom-dropdown>
      <div class="emptyList" v-if="selectedTenant.id===-1">Please select any tenant</div>
      <div v-else-if="tenantUsers.length" class="usersList">
        <div class="boxes">
          <user-multi-select-dropdown
            default-label="Select users"
            :options="tenantUsers"
            :initially-selected="initiallySelectedUsers"
            :defaultStyle="{ ddMaxWidth: '100%' }"
            @selected="setSelectedUsersToShare"
          />
        </div>
      </div>
      <div v-else class="emptyList" >
         There is no users to share in this tenant
      </div>
          <div class="s flex-end">
          <button class="btn btn-cancel mr-2" @click="$emit('close')">Cancel</button>
          <button class="btn" @click="handleShareBom" :disabled="!canShareSelectedUsers">Share</button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { alert, success } from '../../plugins/notification'
import Loader from '@/plugins/loader'
import { GetAllCollabaratorList, ShareBom, GetUsersWithAccessToSharedBom, RemoveSharedBomAccess, removeDocAccess, ShareDocument, GetUsersWithAccessToShareDocument, addComments } from '@/api'
import CustomDropdown from './customDropdown.vue'
import UserMultiSelectDropdown from './userMultiSelectDropdown.vue'

export default {
  name: 'shareBomBody',
  data: () => ({
    collaborators: [],
    selectedTenant: { id: -1, name: 'Select tenant' },
    tenantSearchText: '',
    tenantUsers: [],
    selectedUsersToShareMap: {},
    selectedUsersForDisplayMap: {},
    peopleWithAccess: [],
    initiallySelectedUsers: []
  }),
  props: {
    id: {
      // this is bom id
      required: true
    },
    versionId: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    level: {
      type: String,
      default: 'master'
    }
  },
  components: {
    CustomDropdown,
    UserMultiSelectDropdown
  },
  filters: {
    avatarChar (username = 'User') {
      const afterSplit = username.toUpperCase().trim().split(' ')
      if (afterSplit.length === 1) return afterSplit[0].trim()[0]
      else if (afterSplit.length === 2) return afterSplit[0].trim()[0] + afterSplit[1].trim()[0]
      else if (afterSplit.length > 2) { return afterSplit[0].trim()[0] + afterSplit.at(-1).trim()[0] }
    }
  },
  computed: {
    ...mapGetters(['user', 'tenantList', 'isOnProjectLevel']),
    canShareSelectedUsers () {
      return this.selectedUsersForDisplay.length > 0
    },
    selectedUsersForDisplay () {
      return Object.values(this.selectedUsersForDisplayMap).flat()
    },
    showRemoveButtonProject () {
      return this.isOnProjectLevel && (this.user.projectLevelRole === 'ADMIN' || this.user.projectLevelRole === 'COLLABORATOR' || this.user.projectLevelRole === 'EDITOR')
    },
    showRemoveButtonMaster () {
      return !this.isOnProjectLevel && (this.user.projectLevelRole === 'ADMIN' || this.user.projectLevelRole === 'COLLABORATOR' || this.user.projectLevelRole === 'EDITOR')
    }

  },
  methods: {
    removeAccess (id, name, assocId) {
      const loader = new Loader()
      loader.show()
      if (this.item === 'document') {
        removeDocAccess(assocId).then(() => {
          this.peopleWithAccess = this.peopleWithAccess.filter((item) => item.id !== id)
          success(`Removed the access of ${ name }`)
        }).catch(() => {
          alert('Failed to remove access')
        }).finally(() => {
          loader.hide()
        })
      } else if (this.item === 'bom') {
        RemoveSharedBomAccess(assocId).then(() => {
          this.peopleWithAccess = this.peopleWithAccess.filter((item) => item.id !== id)
          success(`Removed the access of ${ name }`)
          addComments(
            'bom',
            id,
            `Removed the access of ${ name }`,
            null,
            null
          )
        }).catch(() => {
          alert('Failed to remove access')
        }).finally(() => {
          loader.hide()
        })
      }
    },
    handleShareBom () {
      const loader = new Loader()
      let token = 'tenant'
      if (this.level === 'project') {
        token = 'project'
      }
      const usersToShare = []
      for (const users of Object.values(this.selectedUsersToShareMap)) {
        for (const user of users) {
          usersToShare.push(user)
        }
      }
      if (!usersToShare.length) {
        alert('Please select the users.')
        return false
      }
      loader.show()
      if (this.item === 'bom') {
        ShareBom(usersToShare, token).then((res) => {
          success('Successfully shared')
        }
        ).catch(() => {
          alert('Failed to share')
        }).finally(() => {
          loader.hide()
          this.$emit('close')
        })
      } else if (this.item === 'document') {
        let level = 'tenant'
        if (this.isOnProjectLevel) {
          level = 'project'
        }
        ShareDocument(usersToShare, level).then((res) => {
          success('Successfully shared the document')
        }).catch(() => {
          alert('Failed to share')
        }).finally(() => {
          loader.hide()
          this.$emit('close')
        })
      }
    },
    setSelectedUsersToShare (users) {
      if (users.length) {
        this.$set(this.selectedUsersForDisplayMap, this.selectedTenant.id, users)
      } else {
        this.$delete(this.selectedUsersForDisplayMap, this.selectedTenant.id)
      }
      if (this.item === 'bom') {
        const payload = users.map((item) => {
          return {
            target_tenant_user_id: item.value,
            target_tenant_id: this.selectedTenant.id,
            bom_id: this.$props.id,
            bom_version_id: this.$props.versionId
          }
        })
        if (payload.length) {
          this.$set(this.selectedUsersToShareMap, this.selectedTenant.id, payload)
        } else {
          this.$delete(this.selectedUsersToShareMap, this.selectedTenant.id)
        }
      } else if (this.item === 'document') {
        const payload = users.map((item) => {
          return {
            target_tenant_user_id: item.value,
            target_tenant_id: this.selectedTenant.id,
            document_id: this.id
          }
        })
        if (payload.length) {
          this.$set(this.selectedUsersToShareMap, this.selectedTenant.id, payload)
        } else {
          this.$delete(this.selectedUsersToShareMap, this.selectedTenant.id)
        }
      }
    },
    selectTenant (tenant) {
      this.tenantUsers = []
      this.selectedTenant = tenant
      this.tenantSearchText = ''
      if (this.selectedUsersToShareMap[this.selectedTenant.id]) {
        this.initiallySelectedUsers = this.selectedUsersToShareMap[this.selectedTenant.id].map((item) => item.target_tenant_user_id)
      } else {
        this.initiallySelectedUsers = []
      }
      this.getUsersOfTheTenant(this.selectedTenant.id)
    },
    removeSelectedUser (user) {
      const tenantId = user.tenantId
      const nextUsers = (this.selectedUsersForDisplayMap[tenantId] || []).filter(item => item.value !== user.value)
      if (nextUsers.length) {
        this.$set(this.selectedUsersForDisplayMap, tenantId, nextUsers)
      } else {
        this.$delete(this.selectedUsersForDisplayMap, tenantId)
      }

      const nextPayload = (this.selectedUsersToShareMap[tenantId] || []).filter(item => item.target_tenant_user_id !== user.value)
      if (nextPayload.length) {
        this.$set(this.selectedUsersToShareMap, tenantId, nextPayload)
      } else {
        this.$delete(this.selectedUsersToShareMap, tenantId)
      }

      if (String(this.selectedTenant.id) === String(tenantId)) {
        this.initiallySelectedUsers = nextUsers.map(item => item.value)
      }
    },
    getUsersOfTheTenant (id) {
      this.tenantUsers = this.collaborators.find((item) => item.id === id)?.users.map((item) => {
        return {
          value: item?.associated_user?.id,
          label: item?.associated_user?.first_name + ' ' + item?.associated_user?.last_name,
          subLabel: this.selectedTenant.name,
          tenantId: id
        }
      }).filter((item) => {
        if (this.peopleWithAccess.find((user) => user.id === item.value)) {
          return false
        } else return true
      }
      )
    }
  },
  mounted () {
    const loader = new Loader()
    loader.show()
    if (this.item === 'bom') {
      const getUsersWithAccessToSharedBom = GetUsersWithAccessToSharedBom(this.$props.id, this.isOnProjectLevel)
      const getAllCollabaratorList = GetAllCollabaratorList(this.isOnProjectLevel)
      Promise.all([
        getUsersWithAccessToSharedBom,
        getAllCollabaratorList
      ]).then(([peopleWithAccess, collaboratorList]) => {
        this.peopleWithAccess = peopleWithAccess.collaborator_boms.map((item) => {
          return {
            assocId: item.id,
            id: item.tenant_user_association_by_target.associated_user.id,
            name: item.tenant_user_association_by_target.associated_user.first_name + ' ' +
            item.tenant_user_association_by_target.associated_user.last_name,
            sharedById: item.created_by_user.id // storing the id who shared to the user
          }
        })

        const ChildCollaborator = collaboratorList.tenant_company_association.filter((item) => item.target_tenant.status === 1)
        this.collaborators = ChildCollaborator.map((item) => {
          return {
            id: item?.target_tenant?.id,
            name: item?.target_tenant?.company_name,
            users: item?.target_tenant?.tenant_users
          }
        })
      }).catch(() => {
        alert('Failed to fetch')
      }).finally(() => {
        loader.hide()
      })
    } else if (this.item === 'document') {
      const getUsersWithAccessToSharedDocument = GetUsersWithAccessToShareDocument(this.$props.id)
      const getAllCollabaratorList = GetAllCollabaratorList()
      Promise.all([
        getUsersWithAccessToSharedDocument,
        getAllCollabaratorList
      ]).then(([peopleWithAccess, collaboratorList]) => {
        this.peopleWithAccess = peopleWithAccess.collaborator_documents.map((item) => {
          return {
            assocId: item.id,
            id: item.tenant_user_association_by_target.associated_user.id,
            name: item.tenant_user_association_by_target.associated_user.first_name + ' ' +
            item.tenant_user_association_by_target.associated_user.last_name,
            sharedById: item.created_by_user.id, // storing  the id who shared to the user
            tenantName: item.tenant_user_association_by_target?.tenant?.company_name
          }
        })
        const ChildCollaborator = collaboratorList.tenant_company_association
        this.collaborators = ChildCollaborator.map((item) => {
          return {
            id: item?.target_tenant?.id,
            name: item?.target_tenant?.company_name,
            users: item?.target_tenant?.tenant_users
          }
        })
      }).catch(() => {
        alert('Failed to fetch')
      }).finally(() => {
        loader.hide()
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.usersList {
  // height: 24rem;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .boxes{
     margin-bottom: 12px;
  }
}

.shareBody {
  padding: 5px;
  min-width: 30rem;
  &-access-title {
    font-weight: 400;
    font-size: var(--text-sm);
  }
  &-select {
    margin-top: 15px;
  }
  &-remove-btn{
    font-size: var(--text-xs);
    font-weight: 400;
    padding: 5px 5px;
     &:disabled{
      opacity: 0.6;
      cursor: not-allowed;
     }
  }
}

.tenant-search-box {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.tenant-search-input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 10px;
  outline: none;

  &:focus {
    border-color: var(--brand-color);
  }
}

.emptyList {
  font-size: var(--text-xs2);
  color: #7c8390;
  font-style: italic;
  text-align: center;
  padding-block: 2rem;
}

.selected-users-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
//  margin-bottom: 12px;
  max-height: 300px;
  min-height: 0;
  overflow-y: auto;
}

.selected-user-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 12px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.selected-user-details{
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 5px;
  &-avatar {
          border-radius: 50%;
          padding: 16px;
          background-color:rgba(180, 54, 199, 0.1);
          width: 2em;
          height: 2em;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1em;
          font-weight: 300;
          color: rgba(180, 54, 199);
        }
}

.selected-user-name {
  font-size: var(--text-xs2);
  font-weight: 400;
}

.selected-user-tenant {
  font-size: var(--text-xs);
  color: #7d838f;
  margin-top: 2px;
}

.selected-user-remove {
  border: 0;
  background: transparent;
  color: #c2410c;
  cursor: pointer;
  font-size: var(--text-xs);
  padding: 0;
  white-space: nowrap;
}

.accessList{
    border-radius:0.3rem;
    padding: 5px;
    margin-top: 3px;
    margin-bottom: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: blanchedalmond;
}

$color_1: #ddd;
$border-top-color_1: transparent;
$border-left-color_1: transparent;

/*Checkboxes styles*/
input[type="checkbox"] {
  display: none;
  + {
    label {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 20px;
      font: 14px/20px "Open Sans", Arial, sans-serif;
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      &:last-child {
        margin-bottom: 0;
      }
      &:before {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        border: 2px solid var(--brand-color);
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0.6;
        -webkit-transition: all 0.12s, border-color 0.08s;
        transition: all 0.12s, border-color 0.08s;
      }
    }
  }
  &:checked {
    + {
      label {
        &:before {
          width: 10px;
          top: -5px;
          left: 5px;
          border-radius: 0;
          opacity: 1;
          border-top-color: $border-top-color_1;
          border-left-color: $border-left-color_1;
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
        }
      }
    }
  }
}

</style>
